import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { useIsAuthenticated } from '@azure/msal-react'
import NProgress from 'nprogress'
import userManager from '../userManager'
import { Helmet } from 'react-helmet'
import { esRutaSinAutenticacion } from '../services/rutasSinAutenticacion'
// import Loader from 'components/cui-layout/Loader'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
}

const mapStateToProps = ({ user }) => ({ user })
let previousPath = ''

const Layout = ({ user, children, location: { pathname, search } }) => {
  const isAuthenticated = useIsAuthenticated()

  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    // Sin sesión, la página de impresión se sirve desnuda: MainLayout monta el menú y el perfil del
    // usuario, que se piden a la API con token. Con sesión se comporta como siempre, así que el
    // operario que la abre desde el admin no nota ningún cambio.
    if (!isAuthenticated && esRutaSinAutenticacion(pathname)) {
      return 'public'
    }
    return 'main'
  }

  // auth for demo build, remove it in your app
  const DEMO_AUTH = true

  const Container = Layouts[getLayout()]
  const isUserAuthorized = DEMO_AUTH || user.authorized
  const isUserLoading = user.loading
  const isAuthLayout = getLayout() === 'auth'
  const useDefaultHelmetTitle = !/^\/ventas\/edit(\/|$)/i.test(pathname)

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized) {
      userManager.signinRedirect()
      return null
    }
    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      {useDefaultHelmetTitle && <Helmet titleTemplate="%s" title="Regalo Original" />}
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
